import React, { SyntheticEvent, useState } from 'react';
import {
  CircularProgress,
  Autocomplete,
  debounce,
  TextField,
} from '@mui/material';
import { IPostcode } from '../../Interfaces/IPostcode';
import { useSearchPostcodes } from '../../hooks/PostcodeQueries';

interface IProps {
  postcodeObject: IPostcode | null | undefined;
  updatePostcodeObject: (value: IPostcode | null | undefined) => void;
  required?: boolean;
}

export const PostcodeSearchV3 = ({
  postcodeObject,
  updatePostcodeObject,
  required,
}: IProps) => {
  const [open, setOpen] = useState(false);

  const [searchTerm, setSearchTerm] = useState('');
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState(searchTerm);

  const { postcodes, isLoadingPostcodes, abortSearchPostcodes } =
    useSearchPostcodes(debouncedSearchTerm);

  const options = postcodes ?? [];

  const handleSearchTermChange = (_: SyntheticEvent, searchTerm: string) => {
    abortSearchPostcodes();
    setSearchTerm(searchTerm);
    const debouncedSearchTerm = debounce(setDebouncedSearchTerm, 500);

    debouncedSearchTerm(searchTerm);
  };

  return (
    <Autocomplete
      id='searchbar-postcode'
      fullWidth
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      value={postcodeObject}
      inputValue={searchTerm}
      isOptionEqualToValue={(option, value) =>
        option.idPostcode === value.idPostcode
      }
      filterOptions={x => x}
      getOptionLabel={option => `${option.Postcode} ${option.City}`}
      loadingText='Laden...'
      options={options}
      loading={isLoadingPostcodes}
      getOptionKey={option =>
        `${option.idPostcode}-${option.idCountry}-${option.City}`
      }
      onInputChange={handleSearchTermChange}
      onChange={(_, newObject) => updatePostcodeObject(newObject)}
      renderInput={params => (
        <TextField
          {...params}
          label='Postleitzahl'
          placeholder='Postleitzahl eingeben'
          size='small'
          required={required ?? true}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {isLoadingPostcodes && (
                  <CircularProgress color='inherit' size={20} />
                )}
                {searchTerm && params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
        />
      )}
    />
  );
};
